import React from "react";
import Navigation from "../../elements/navigation/Navigation";
import LogoHomeHeader from "./LogoHomeHeader";
import SidebarContainerHeaderHome from "./SidebarContainerHeaderHome";
import { StyledHeaderHomePageBlock, StyledHeaderHomePageSection } from "./styledHomePageHeaders";

const HomePageHeader = ({ inViewport, userInfo, fetchUser }) => {

  return (
    <>
      <StyledHeaderHomePageSection>
        <StyledHeaderHomePageBlock>
          <div className="header-left">
            <LogoHomeHeader />
          </div>
          <Navigation inViewport={inViewport} />
          <div className="header-right">
            <SidebarContainerHeaderHome
              fetchUser={fetchUser}
              userInfo={userInfo}
            />
          </div>
        </StyledHeaderHomePageBlock>
      </StyledHeaderHomePageSection>
    </>
  );
};

export default HomePageHeader;